"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WeekRow = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = _interopRequireDefault(require("../../../../styled"));

var _CalendarGrid = require("./CalendarGrid");

var _DayCell = require("./DayCell");

var _types = require("../../date-parts/types");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var WeekElement = (0, _styled["default"])(_CalendarGrid.CalendarGridRowElement)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var WeekRow = function WeekRow(_ref) {
  var dates = _ref.dates,
      min = _ref.min,
      max = _ref.max,
      selected = _ref.selected,
      display = _ref.display,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      isSelectingRange = _ref.isSelectingRange,
      maxSelectedDate = _ref.maxSelectedDate,
      minSelectedDate = _ref.minSelectedDate,
      maxSelectingDate = _ref.maxSelectingDate,
      minSelectingDate = _ref.minSelectingDate;
  return /*#__PURE__*/_react["default"].createElement(WeekElement, null, dates.map(function (date, index) {
    return date ? /*#__PURE__*/_react["default"].createElement(_DayCell.DayCell, {
      date: date,
      min: min,
      max: max,
      selected: selected,
      display: display,
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      isSelectingRange: isSelectingRange,
      maxSelectedDate: maxSelectedDate,
      minSelectedDate: minSelectedDate,
      maxSelectingDate: maxSelectingDate,
      minSelectingDate: minSelectingDate,
      key: "".concat(display[_types.DatePartEnum.YEAR], "\n              -").concat(display[_types.DatePartEnum.MONTH], "\n              -").concat(date)
    }) : /*#__PURE__*/_react["default"].createElement(_CalendarGrid.CalendarGridCellElement, {
      key: index
    });
  }));
};

exports.WeekRow = WeekRow;